module.exports = __webpack_public_path__ + "img/floating-image-1@2x.2619305b.png";